import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import Modal from '../../../commonComponents/modal/Modal';

function ShopModalOrderComplete(
  { t,
    closeModal,
    goBackMessage,
    urlGoBack,
    urlGoToOrder,
    modalMessage,
    confirmMessage,
    showBack }) {
  return (
    <Modal id="completed-order-modal" tabIndex={null}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="m--font-inverse-primary">{t('shop.order_modal_title')}</h3>
          </div>
          <div className="modal-body">
            <div className="modal-text">
              <div>{modalMessage || t('shop.order_modal_order_on_its_way')}</div>
              {!modalMessage && <div>{t('shop.order_modal_check_status')}</div>}
            </div>
          </div>
          <div className="modal-footer">
            <div className="footer-buttons">
              {showBack && (
                <div className="footer-single-button">
                  <a
                    href={urlGoBack}
                    className="btn m-btn--pill btn-outline-metal m-btn--air"
                    onClick={closeModal}
                  >
                    {goBackMessage || t('shop.order_modal_back_marketplace')}
                  </a>
                </div>
              )}
              <div className="footer-single-button">
                <a
                  href={urlGoToOrder}
                  className="btn m-btn--pill btn-dynamic btn-success-modal"
                  onClick={closeModal}
                >
                  {confirmMessage || t('shop.order_modal_track_order')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ShopModalOrderComplete.propTypes = {
  t: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  goBackMessage: PropTypes.string,
  urlGoBack: PropTypes.string,
  urlGoToOrder: PropTypes.string,
  modalMessage: PropTypes.string,
  confirmMessage: PropTypes.string,
  showBack: PropTypes.bool,
};

ShopModalOrderComplete.defaultProps = {
  confirmMessage: null,
  goBackMessage: null,
  modalMessage: null,
  showBack: true,
  urlGoBack: '/shop',
  urlGoToOrder: '/shop/order',
};

export default translate(ShopModalOrderComplete);
